import React from 'react';
import AspectRatio from 'components/aspect-ratio';
import Button from 'components/control/button';
import styles from './style.module.scss';
import { testIds } from 'constants/test-constants';
import Image from 'next/image';

import type { IUserLocation } from 'utils/user-location';

export type WidgetCTACardProps = {
  userLocation: IUserLocation;
};

/** The widget version of the CTACard. It does not support localization and strings are hardcoded. */
export function WidgetCTACard({ userLocation }: WidgetCTACardProps) {
  const href = `/${userLocation?.slug ? userLocation.slug + '-' : '' }real-estate`;
  const ctaText = 'Filter by price, property type, square footage, and more to find homes for sale in your area.';
  return (
    <div className={styles.component} data-testid={testIds.ctaCard}>
      <div className={styles.top}>
        <AspectRatio ratio="4:3">
          <Image src='/next/assets/images/brush-stroke-2.png' className={styles.image} alt='Brush stroke' fill/>
          <div className={styles.text}>
            <p>Looking for more properties?</p>
            <a href={href} target="_blank" rel="noreferrer"><Button label="View More" theme="primary" /></a>
          </div>
        </AspectRatio>
      </div>
      <div className={styles.bottom}>
        <p>{ctaText}</p>
      </div>
    </div>
  );
}